<template>
  <div>
    <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
      <v-tab> اطلاعات عمومی</v-tab>
      <v-tab> سابقه فعالیت ها </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <user-info />
        <div class="addressButton">
          <v-btn color="primary white--text" rounded @click="goToOld"
            >نسخه قدیم پرتال طلاب</v-btn
          >
          <v-btn color="green white--text" rounded @click="goToApp"
            >دانلود اپلیکیشن اندروید</v-btn
          >
        </div>
      </v-tab-item>
      <v-tab-item> <group-info /> </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import UserInfo from "./UserInfo";
import GroupInfo from "./GroupInfo";

export default {
  components: {
    userInfo: UserInfo,
    groupInfo: GroupInfo,
  },
  data() {
    return {
      tab: null,
    };
  },
  methods: {
    goToOld() {
      window.open("https://hozehkh.com/Students/");
    },
    goToApp() {
      window.open("https://www.hozehkh.com/res/android/portal.apk", "_self");
    },
  },
};
</script>
<style scoped>
.addressButton {
  width: unset;
  margin-top: 40px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  padding-bottom: 10px;
}
.addressButton .v-btn {
  margin: 5px 10px;
}
</style>
